<template>
  <router-view />
</template>

<script>
export default {
  mounted () {
    console.log('category View');
  },
}
</script>

<style scoped>

</style>
